<button class="flex flex-col items-center justify-center w-[5rem] h-full"
        [disabled]="action.canExecute && !(action.canExecute | async)"
        (click)="action.execute()"
        (mousedown)="$event.stopPropagation()"
        [ngClass]="action.class">
  <i *ngIf="action.icon" [ngClass]="action.icon"></i>
  <span class="text-xs">{{action.title | translate}}</span>
</button>
